/**
 * DEVICE-LOCAL change-tracking columns shared by every synced table (see
 * `packages/core/src/sync/device-local.ts` for the model). `mut` is bumped by
 * the repository chokepoint on every local write of synced content; the
 * `*_acked_mut` columns record the `mut` a successful upload carried.
 * Labels/topics omit `google_acked_mut` — they never reach Google.
 */
export function MUT_ALTERS(table: string, opts?: { google?: boolean }): string[] {
  const cols = ["mut", "server_acked_mut", ...(opts?.google === false ? [] : ["google_acked_mut"])];
  return cols.map((c) => `ALTER TABLE ${table} ADD COLUMN ${c} INTEGER NOT NULL DEFAULT 0;`);
}
